<template>
  <!-- <page> -->
  <div :load="doInit">
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel1" multiple>
            <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-icon>mdi-filter-variant</v-icon> {{labels.dateRange}}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="reportForm.tranDateFrom" :label="labels.tranDateFrom" :data-vv-as="labels.tranDateFrom"
                          data-vv-name="reportForm.tranDateFrom" :error-messages="errors.collect('reportForm.tranDateFrom')" v-validate="tranDateFromValidation"></cal-picker>
                        </v-flex>
                        <v-flex xs12 sm6 md6 lg6>
                          <cal-picker v-model="reportForm.tranDateTo" :label="labels.tranDateTo" :data-vv-as="labels.tranDateTo"
                          data-vv-name="reportForm.tranDateTo" :error-messages="errors.collect('reportForm.tranDateTo')" v-validate="tranDateToValidation"></cal-picker>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-spacer class="mt-2"></v-spacer>
          <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
                <v-expansion-panel-header>
                  <div>
                    <v-icon>mdi-filter-variant</v-icon> {{labels.filters}}
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="ePanelHeaderColor">
                <v-card>
                  <v-card-text>
                    <v-container fluid grid-list-sm>
                      <v-layout row wrap>
                        <v-flex xs12 md6 lg6>
                          <v-autocomplete :items="rptByList" v-model="reportForm.rptBy" :label="labels.rptBy" item-text="label" item-value="value" data-vv-name="reportForm.reportBy" :data-vv-as="labels.reportBy" :error-messages="errors.collect('reportForm.reportBy')"></v-autocomplete>
                        </v-flex>
                        <!-- Executive In-charge -->
                        <v-flex lg12 md12 xs12>
                          <v-text-field v-model="reportForm.execIC" :label="labels.execIC" :error-messages="errors.collect('execIC')" data-vv-name="execIC"
                          :data-vv-as="labels.execIC" append-icon="mdi-magnify" @click:append="getHelpList('execIC')" readonly></v-text-field>
                        </v-flex>
                        <!-- Intermediary Type -->
                        <v-flex lg12 md12 xs12>
                          <v-text-field v-model="reportForm.interType" :label="labels.interType" :error-messages="errors.collect('interType')" data-vv-name="interType"
                          :data-vv-as="labels.interType" append-icon="mdi-magnify" @click:append="getHelpList('interType')" readonly></v-text-field>
                        </v-flex>
                        <!-- Billing Account -->
                        <v-flex lg12 md12 xs12>
                          <v-text-field v-model="reportForm.inter" :label="labels.inter" :error-messages="errors.collect('inter')" data-vv-name="inter"
                          :data-vv-as="labels.inter" append-icon="mdi-magnify" @click:append="getHelpList('inter')" readonly></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>
        <v-flex xs12>
          <v-checkbox
            :label="labels.pbPrtParam"
            v-model="reportForm.pbPrtParam"
            :error-messages="errors.collect('pbPrtParam')"
            data-vv-name="pbPrtParam"
            :data-vv-as="labels.pbPrtParam"
          />
        </v-flex>
        <v-flex xs12 sm6 md6 lg6>
          <v-btn color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="reportForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Executive In-charge HelpList -->
    <v-dialog v-model="execICHelpList" width="900px" persistent>
      <multi-exec-in-charge-help-list :execic="reportForm.execIC" @close="doClose" @doAssign="doAssign($event)"></multi-exec-in-charge-help-list>
    </v-dialog>
    <!-- Intermediary Type HelpList -->
    <v-dialog v-model="interTypeHelpList" width="900px" persistent>
      <multi-acct-type-help-list :acctType="reportForm.interType" @close="doClose" @doAssign="doAssign($event)"></multi-acct-type-help-list>
    </v-dialog>
    <!-- Billing Account HelpList -->
    <v-dialog v-model="interHelpList" width="900px" persistent>
      <multi-intermediary-help-list :intr="reportForm.inter" @close="doClose" @doAssign="doAssign($event)"></multi-intermediary-help-list>
    </v-dialog>

  </div>
  <!-- </page> -->
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import { removeTime } from '@/utils/date'
import isAfter from 'date-fns/isAfter'
import MultiExecInChargeHelpList from '@/components/core/common/dialog/MultiExecInChargeHelpList'
import MultiIntermediaryHelpList from '@/components/core/common/dialog/MultiIntermediaryHelpList'
import MultiAcctTypeHelpList from '@/components/core/common/dialog/MultiAcctTypeHelpList'
import { rptByList } from './index'

export default {
  data() {
    return {
      labels: {
        dateRange: 'Date Range',
        filters: 'Selection Criteria',
        tranDateFrom: 'Transaction Date From*',
        tranDateTo: 'Transaction Date To*',
        rptBy: 'Report By',
        execIC: 'Executive In-charge(s)',
        interType: 'Intermediary Type(s)',
        inter: 'Billing Agent(s)',
        export: 'Export To',
        format: 'ASCII TEXT',
        pbPrtParam: 'Print Runtime Parameters'
      },
      reportForm: {
        tranDateFrom: null,
        tranDateTo: null,
        rptBy: 'I',
        execIC: 'All',
        interType: 'All',
        inter: 'All',
        format: undefined,
        pbPrtParam: true
      },
      loading: false,
      menu: {},
      supportedFormat: [],
      // helplist
      field: null,
      execICHelpList: false,
      interTypeHelpList: false,
      interHelpList: false,
      rptByList: [],
      panel1: [0],
      panel2: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    },
    tranDateFromValidation() {
      if (this.reportForm.tranDateFrom !== '' && this.reportForm.tranDateFrom !== null && this.reportForm.tranDateFrom !== undefined) {
        return 'entry|valTranDateFrom:' + this.reportForm.tranDateTo
      } else {
        return 'required'
      }
    },
    tranDateToValidation() {
      if (this.reportForm.tranDateTo !== '' && this.reportForm.tranDateTo !== null && this.reportForm.tranDateTo !== undefined) {
        return 'entry|valTranDateTo:' + this.reportForm.tranDateFrom
      } else {
        return 'required'
      }
    }
  },
  watch: {
  },
  methods: {
    async doInit() {
      this.reportForm.tranDateTo = new Date()
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await Promise.all([this.$store.dispatch('uwReportsInit')])
        }
        const apiURI = this.rptMenu.initProdStats
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    getHelpList(field) {
      this.field = field
      switch (field) {
        case 'execIC':
          this.execICHelpList = true
          break
        case 'interType':
          this.interTypeHelpList = true
          break
        case 'inter':
          this.interHelpList = true
          break
        default:
          this.execICHelpList = false
          this.interTypeHelpList = false
          this.interHelpList = false
      }
    },
    async doAssign(Obj) {
      switch (this.field) {
        case 'execIC':
          this.reportForm.execIC = Obj.finalSelectedItems.toString()
          break
        case 'interType':
          this.reportForm.interType = Obj.finalSelectedItems.toString()
          break
        case 'inter':
          this.reportForm.inter = Obj.finalSelectedItems.toString()
          break
        default:
          this.reportForm.execIC = 'All'
          this.reportForm.interType = 'All'
          this.reportForm.inter = 'All'
      }
    },
    doClose() {
      this.field = null
      this.execICHelpList = false
      this.interTypeHelpList = false
      this.interHelpList = false
    },
    async processExport() {
      const apiURI = this.menu.generateProdExecAgent
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.reportForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  created() {
    this.rptByList = rptByList
    this.$validator.extend('valTranDateFrom', {
      getMessage(field, args) {
        return 'Must be same date or earlier date than To Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranFromDate = args[0]
        if (tranFromDate) {
          return !(isAfter(removeTime(value), removeTime(tranFromDate)))
        }
      }
    })

    this.$validator.extend('valTranDateTo', {
      getMessage(field, args) {
        return 'To Date must be greater or equal to From Date'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var tranToDate = args[0]
        if (tranToDate) {
          return !(isAfter(removeTime(tranToDate), removeTime(value)))
        }
      }
    })
  },
  beforeMount() {
    if (this.$store.state.underwriting.dataTransferSettings.init !== 1) {
      this.$store.dispatch('dataTransferInit').then(() => {
        this.doInit()
      })
    } else {
      this.doInit()
    }
  },
  mixins: [
    MessageMixin
  ],
  components: {
    MultiExecInChargeHelpList,
    MultiAcctTypeHelpList,
    MultiIntermediaryHelpList
  }
}
</script>

<style>

</style>
